import React from 'react';
import styles from './uom-set.scss';
import { UomSetProps } from 'app/area/codetable/item/types';
import { SubstanceSetUomType } from 'app/area/codetable/item/screen-renderer/screen-pickers/substance/sets/substance-uom-type';
import { SubstanceSetUom } from 'app/area/codetable/item/screen-renderer/screen-pickers/substance/sets/substance-uom';
import { IndicatorSetUomType } from 'app/area/codetable/item/screen-renderer/screen-pickers/substance/sets/indicator-uom-type';
import { IndicatorSetUom } from 'app/area/codetable/item/screen-renderer/screen-pickers/substance/sets/indicator-uom';

export const UomSet: React.FC<UomSetProps> = (props) => (<div className={styles.uomSetContainer}>
  <div className={styles.uomSet}>
    <div className={styles.uomSetHeader}>
      <div>
        <h3>{props.substanceUomSetValue && props.substanceUomSetValue.uomSet.description}</h3>
      </div>
    </div>
    <ol className={styles.uomSetContent}>
      <div>
        <div>
          <h4>{props.translation.uom_set_substance}</h4>
          <div className="row">
            <SubstanceSetUomType {...props} />
            <SubstanceSetUom {...props} />
          </div>
        </div>

        <div>
          <h4>{props.translation.uom_set_indicator}</h4>
          <div className="row">
            <IndicatorSetUomType {...props} />
            <IndicatorSetUom {...props} />
          </div>
        </div>
      </div>
    </ol>
  </div>
</div>);
